import { create } from 'zustand';

const STORAGE_KEY = 'ridgen-prep-active-season';

interface PrepActiveSeasonStore {
  seasonId: string | null;
  setSeason: (id: string) => void;
  clearSeason: () => void;
}

function loadFromStorage(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function saveToStorage(id: string | null): void {
  try {
    if (id) {
      localStorage.setItem(STORAGE_KEY, id);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // localStorage unavailable — continue without persistence
  }
}

export const usePrepActiveSeasonStore = create<PrepActiveSeasonStore>((set) => ({
  seasonId: loadFromStorage(),

  setSeason: (id) => {
    saveToStorage(id);
    set({ seasonId: id });
  },

  clearSeason: () => {
    saveToStorage(null);
    set({ seasonId: null });
  },
}));
